export default "__VITE_ASSET__CXp9zfSc__"